import { Component, inject, Input, OnInit } from '@angular/core';
import { DatePipe }                         from '@angular/common';
import { ComponentType }                    from '../components.utils';

import { BankCustomizationData, SessionService } from '../../../api/session/session.service';
import { InternalRoutes }                        from '../../data/internal-routes';
import { BankFooterLogoComponent }               from '../../../components/bank-footer-logo/bank-footer-logo.component';
import { ButtonComponent }                       from '../buttons/button.component';

@Component({
  selector: 'pin-footer',
  templateUrl: './footer.component.html',
  imports: [BankFooterLogoComponent, ButtonComponent, DatePipe]
})
export class FooterComponent implements OnInit {
  @Input()
  customClass: string;
  @Input()
  type: string;
  copyrightType = ComponentType;
  currentDate = Date.now();
  bankCustomizationData: BankCustomizationData;
  privacyPolicyRoute = InternalRoutes.PRIVACY_POLICY;
  private sessionService = inject(SessionService);

  ngOnInit() {
    if (this.isAuthenticated()) {
      this.getSession();
    }
  }

  getSession() {
    this.sessionService.loadSession().subscribe(
      data => {
        this.bankCustomizationData = data.bankCustomizationData;
      });
  }

  footerLogoAndCopyrightIsDisplayed() {
    return this.isAuthenticated() &&
      !!this.bankCustomizationData?.footerLogoFileName &&
      !!this.bankCustomizationData?.footerCopyrightAndDisclaimerMessage;
  }

  isAuthenticated() {
    return this.type == ComponentType.AUTHENTICATED;
  }
}
